import { render } from "./Language.vue?vue&type=template&id=642f3f49"
import script from "./Language.vue?vue&type=script&lang=js"
export * from "./Language.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./Language.vue?vue&type=style&index=0&id=642f3f49&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script